import { useQuery } from 'react-query';

import { getCacheSettings } from 'common/helpers/caching';
import { getEmptyPage, IPaging, IQueryParameters } from 'common/models';
import { QUERY_KEYS } from 'consts/queryKeys';
import { getReservations } from 'modules/accommodations/features/reservations/api';

interface IProps extends IPaging, IQueryParameters {
  isEnabled: boolean;
}

export const useQueryReservations = ({ params, pageNo, pageSize, isEnabled }: IProps) => {
  const {
    data: reservations,
    isError: isErrorReservations,
    isFetching: isFetchingReservations,
    refetch: refetchReservations,
    isLoading: isLoadingReservations,
  } = useQuery(
    [QUERY_KEYS.UNITS_RESERVATIONS, pageNo, params],
    () => getReservations({ params, pageSize, pageNo }),
    {
      // ...getCacheSettings(), // uncomment for loading icon
      enabled: isEnabled,
    },
  );

  return {
    reservations: reservations || getEmptyPage(),
    isFetchingReservations,
    isErrorReservations,
    refetchReservations,
    isLoadingReservations,
  };
};
